import {Dayjs} from 'dayjs';
import {daysOfWeek} from '../../../dto/DateTime.dto';
import {iTimedMsgDateRange} from '../../../pages/messages/timed-message/request/TimedMessageRequest';

export function GetDaysFromDateRange(from: Dayjs, to: Dayjs) {
  const customDaysOfWeek = [];

  const length = to.diff(from, 'day') + 1;

  if (length > 6) {
    return daysOfWeek;
  }

  while (from.isBefore(to) || from.isSame(to)) {
    customDaysOfWeek.push(from.format('dddd'));
    from = from.add(1, 'day');
  }

  return customDaysOfWeek;
}

export function GetDaysFromMultipleDateRange(
  datesArray: {start_date: Dayjs | null; end_date: Dayjs | null}[],
): string[] {
  const customDaysOfWeek: Set<string> = new Set();

  for (const dates of datesArray) {
    if (dates.start_date && dates.end_date) {
      const daysInRange = GetDaysFromDateRange(
        dates.start_date,
        dates.end_date,
      );
      daysInRange.forEach(day => customDaysOfWeek.add(day));
    }

    if (customDaysOfWeek.size === 7) {
      break;
    }
  }

  return daysOfWeek.filter(day => customDaysOfWeek.has(day));
}

export const isAllDaysTimed = (val: iTimedMsgDateRange) => {
  const flattenedWeeks = val.day_times?.map(o => o.selectedDays).flat();
  const uniqueWeeks = flattenedWeeks?.filter(
    (item, index, array) => array.indexOf(item) === index,
  );

  return [...(val.chosenDays || [])].every(
    (d: string) => uniqueWeeks?.includes(d),
  );
};
